<template>
  <div>
    <label class="block text-sm font-medium text-gray-700 mb-2">
      Template
    </label>
    <Select
      v-model="selectedTemplateId"
      :options="templates"
      option-label="name"
      option-value="id"
      :placeholder="placeholder"
      class="w-full"
      show-clear
      :loading="isLoading"
    />
  </div>
</template>

<script setup lang="ts">
import type { MessageTemplate, MessageTemplateType } from '@prisma/client'

const props = withDefaults(defineProps<{
  type?: MessageTemplateType
  placeholder?: string
}>(), {
  type: 'SMS',
  placeholder: 'Select a template (optional)',
})

const selectedTemplateId = defineModel<string | null>('selectedTemplateId', {
  default: null,
})

const emit = defineEmits<{
  (e: 'select', template: MessageTemplate | null): void
}>()

const templates = ref<MessageTemplate[]>([])
const isLoading = ref(false)
const { getAll } = useMessageTemplate()

const loadTemplates = async () => {
  isLoading.value = true
  const { data } = await getAll(props.type)
  templates.value = data || []
  isLoading.value = false
}

watch(selectedTemplateId, (id) => {
  if (id) {
    const template = templates.value.find(t => t.id === id)
    emit('select', template || null)
  }
  else {
    emit('select', null)
  }
})

onMounted(() => {
  loadTemplates()
})
</script>
